import { Constants } from './../../shared/Helpers/constants';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { UserContext } from '../../_context/user.context';
import { UserService, AuthenticationService } from '../../_services';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/shared/shared.service';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';

@Component({
  selector: 'security-questions',
  templateUrl: './security-questions.component.html',
  providers: [UserContext]
})
export class SecurityQuestionsComponent implements OnInit {
  public securityQuestionForm: FormGroup;
  public identityTypeResponse: any;
  public securityQuesitons: any;
  public securityQuestionsList: any;
  public peopleData: any;
  public resetPasswordAfterExpire: boolean;
  public securityQuestionList = [ {label: "Select a security question", value: 123} ];
  public dropdownCurrentQuestion: any = '';
  private returnUrl: any;
  private hostname: any;
  private currentOrganisation: any;
  private currentUrlType: number;

  constructor(
    private _userContext: UserContext,
    private _fb: FormBuilder,
    private _authenticationServices: AuthenticationService,
    private _userService: UserService,
    private _sharedService: SharedService,
    private _router: Router,
    private _route: ActivatedRoute,
  ) {
    this._userContext = new UserContext();
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || environment.default_return_url;
    this.resetPasswordAfterExpire = this._sharedService.passwordExpireFirstLogin.value;
  }

  ngOnInit(): void {
    (this._userContext.userID && this._userContext.organisationID) ? this.getUserById() : this.getPerson();
    this.getHostName();
    this.initSecurityQuestionForm();
  }

  public onSelectSecurityQuestion(secQuestionId: any, index) {
    const allSecurityQuestionsList: Array<any> = [];
    for(let i=0; i < 1; i++) {
      this.securityQuesitons.controls[index].patchValue({
        securityQuestionId : secQuestionId,
        selected: true
      })
    }

    for (let i = 0; i < this.securityQuesitons.controls.length; i++) {
      const object = { 'securityQuestionId': this.securityQuesitons.controls[i].value.securityQuestionId };
      allSecurityQuestionsList.push(object)
    }

    if (allSecurityQuestionsList.length > 0) {
      if (allSecurityQuestionsList.filter(itm => itm.securityQuestionId == secQuestionId).length > 1) {
        for (let i = 0; i < this.securityQuesitons.controls.length; i++) {
          if (this.securityQuesitons.controls[i].value.securityQuestionId == secQuestionId) {
            this.securityQuesitons.controls[i].value.warning = true;
          }
        }
      }

      for (let i = 0; i < this.securityQuesitons.controls.length; i++) {
        if (this.securityQuesitons.controls.filter(item => item.value.warning).length < 2) {
          for(let i = 0; i < this.securityQuesitons.controls.length; i++) {
            this.securityQuesitons.controls[i].value.warning = false;
          }
        }
      }

      if (this.securityQuesitons.controls.filter(item => item.value.warning).length > 1) {
        this.securityQuestionForm.patchValue({
          warning: ''
        })
      } else {
        this.securityQuestionForm.patchValue({
          warning: 'false'
        })
      }
    }
  }

  public submitQuestions() {
    const questions = this.securityQuestionForm.value;

    if (questions.securityQuestion != null) {
      let index = 0;
      questions.securityQuestion.forEach(item => {

        const object = {
          answer: item.answer,
          securityQuestion: {
            id: item.securityQuestionId
          }
        }
        this._userService.postSecurityQuestions(this._userContext.personID, object).subscribe((response) => {
          index++;
          if (index == questions.securityQuestion.length) {
            Alert.basicNotification(AlertTypeEnum.Success, "", "Answers saved");
            this._authenticationServices.logout();
            this._router.navigateByUrl('/login?returnUrl=' + this.returnUrl)
          }
        })
      });
    }
  }

  private initSecurityQuestionForm() {
    this.securityQuestionForm = this._fb.group({
      securityQuestion: this._fb.array([
        this.initSecurityQuestions()
      ]),
      warning: ['false', Validators.required]
    });
    (<FormArray>this.securityQuestionForm.controls.securityQuestion).removeAt(0);
  }

  private initSecurityQuestions() {
    return this._fb.group({
      securityQuestionId: [''],
      answer: [''],
      selected: [false],
      warning: [false]
    });
  }

  private getPerson() {
    this._userService.getPeopleById(this._userContext.personID).subscribe({
      next: (res) => {
        this.peopleData = res.body;
        this._userService.getHomeUser(this.peopleData.id).subscribe((data) => {
          const users = data.body;
          const homeUser = users.find(itm => itm.id == this.peopleData.homeUser.id);
          this.getSecurityQuestions(homeUser.userType.id, homeUser.organisation.id, this.peopleData.identityType.id)
        })
      },
      error: (err) => {
        this.peopleData = {};
      }
    })
  }

  private getUserById() {
    this._userService.getUserByOrganisation(this._userContext.userID, this._userContext.organisationID).subscribe((resp) => {
      const userData = resp.body;
      this.getSecurityQuestions(userData.userType.id, this._userContext.organisationID, userData.person.identityType.id);
    })
  }

  private getSecurityQuestions(userTypeId: any, organisaitonId: any, identityTypeId: any) {
    const securityQuestions = this._userService.getSecurityQuestions(userTypeId, organisaitonId)
    const identityTypes = this._userService.getIdentityById(identityTypeId);

    forkJoin([securityQuestions, identityTypes]).subscribe((results: any) => {
      this.securityQuestionsList = results[0].body;
      this.securityQuestionsList.forEach((element: any) => {
        let questionObject = { label: element.questionText, value:  element.securityQuestionId };
        this.securityQuestionList.push(questionObject);
        this.dropdownCurrentQuestion = this.securityQuestionList[0].label;
      });

      this.identityTypeResponse = results[1].body;
      this.patchSecurityQuestionForm();
    })
  }

  public isSaveEnabled(): boolean {
    if (this.securityQuestionForm.valid) {
      if (this.securityQuestionForm.value.securityQuestion) {
        let filledSecurityQuestions = 0;
        this.securityQuestionForm.value.securityQuestion.forEach(q => {
          if (q.securityQuestionId != '' && q.answer != '') {
            filledSecurityQuestions ++;
          }
        });
        if (filledSecurityQuestions >= this.identityTypeResponse.minSecurityQuestionCount) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  }

  private patchSecurityQuestionForm() {
    this.securityQuesitons = <FormArray>this.securityQuestionForm.controls['securityQuestion'];

    for (let i = 0; i < this.identityTypeResponse.minSecurityQuestionCount; i++) {
      const newSecurityQuesiton = this._fb.group({
        securityQuestionId: [''],
        answer: ['', [Validators.minLength(this.identityTypeResponse.minSecurityQuestionAnswerLengths), Validators.required, Validators.pattern('^[a-zA-Z0-9 ]+$')]],
        selected: [false],
        warning: [false]
      })
      this.securityQuesitons.push(newSecurityQuesiton);
    }
  }

  public skipSecurityQuestionsAfterResetPassword() {
    if ((this.peopleData.contactDetails.length > 0 &&  this.peopleData.contactDetails[0].authorisationStatus == "PENDING") || this.peopleData.contactDetails.length == 0) {

      let titlemessage = 'Warning'
      let textmessage = 'You will be unable to recover your login details without either security questions or a recovery email address.';
      Swal.fire({
        title: titlemessage,
        text: textmessage,
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        customClass: {
          cancelButton: 'btn btn-primary margin-right-base',
          confirmButton: 'btn btn-primary',
        },
      }).then((result) => {
        if (result.dismiss) {
          // do nothing, just hide popup
        } else {
          this._authenticationServices.logout();
          this._router.navigateByUrl('/login?returnUrl=' + this.returnUrl);
        }
      });
    } else {
      this._authenticationServices.logout();
      this._router.navigateByUrl('/login?returnUrl=' + this.returnUrl);
    }
  }

  public enterContextualisation() {
    if ((this.peopleData.contactDetails.length > 0 &&  this.peopleData.contactDetails[0].authorisationStatus == "PENDING") || this.peopleData.contactDetails.length == 0) {
      let titlemessage: string = 'Warning'
      let textmessage: string = 'You will be unable to recover your login details without either security questions or a recovery email address.';
      Swal.fire({
        title: titlemessage,
        text: textmessage,
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        customClass: {
          cancelButton: 'btn btn-primary margin-right-base',
          confirmButton: 'btn btn-primary'
        }
      }).then((result) => {
        if (result.dismiss) {
            // do nothing, just hide popup
        } else {
          if (this._sharedService.currentOrganisationId.value) {
            this.contextualizeToken(this._sharedService.currentOrganisationId.value);
          }
          else {
            if (this.hostname !== environment.default_return_url &&
              ((this.returnUrl != undefined || this.returnUrl != null) && this.returnUrl != environment.default_return_url)) {
              this.contextualizeByOrganisationHostname();
            } else {
              this._userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
                const user = userData.body;
                const filterUser = user.filter(item => item.isHomeUser == true);
                this._sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
                this._sharedService.changeLoggedUserId(filterUser[0].id)
                this.contextualizeToken(filterUser[0].organisation.id);
              });
            }
          }
        }
      });
    } else {
      if (this._sharedService.currentOrganisationId.value) {
        this.contextualizeToken(this._sharedService.currentOrganisationId.value);
      }
      else {
        if (this.hostname !== environment.default_return_url &&
          ((this.returnUrl != undefined || this.returnUrl != null) && this.returnUrl != environment.default_return_url)) {
          this.contextualizeByOrganisationHostname();
        } else {
          this._userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
            const user = userData.body;
            const filterUser = user.filter(item => item.isHomeUser == true);
            this._sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
            this._sharedService.changeLoggedUserId(filterUser[0].id)
            this.contextualizeToken(filterUser[0].organisation.id);
          });
        }
      }
    }
  }

  private contextualizeByOrganisationHostname() {
    this._userService.getOrganisationByUniqueUrl(this.hostname).subscribe({
      next: (res) => {
        this.currentOrganisation = res.body;
        this.currentUrlType = this.currentOrganisation.urlType;
        if (this.currentUrlType == 3) {
          this.returnUrl = environment.default_return_url;
        }
        this._sharedService.changeCurrentOrganisationId(this.currentOrganisation.organisationId);
        this.contextualizeToken(this.currentOrganisation.organisationId);
      },
      error: (err) => {
        // If no organisation was found contextualize token by user's home organisation
        this._userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
          const user = userData.body;
          const filterUser = user.filter(item => item.isHomeUser == true);
          this._sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
          this._sharedService.changeLoggedUserId(filterUser[0].id);
          this.contextualizeToken(filterUser[0].organisation.id);
        });
      }
    });
  }

  // contextualize Token
  private contextualizeToken(organisationId: any) {
    this._userService.contextualizeToken(organisationId).subscribe({
      next: (res) => {
        if (res.status == 200 ) {
          const user = res.body;
          localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
          this._authenticationServices.redirect(this.returnUrl);
        }
      },
      error: (err) => {
        if (err.status === 401 ) {
          if (err.error.errorCode === 1016) {
            // 2fa required, but no configurations for 2fa
            this.getUserIdByErrorMsg(err.error.detailedMessage);
            this._router.navigateByUrl('/2FA-setup');
          }
          // 2fa required and code sent to the last configured method (sms/app)
          else if (err.error.errorCode === 1017) {
            const errMsg: string = err.error.detailedMessage;
            this.getUserIdByErrorMsg(errMsg);
            this._router.navigateByUrl('/2FA-authentication');
          }
          // 2fa required, but the setup of app not fully completed
          else if (err.error.errorCode === 1018) {
            this.getUserIdByErrorMsg(err.error.detailedMessage);
            this._router.navigateByUrl('/2FA-authentication');
          }
        }
        else if (err.status === 422 && err.error.errorCode === 1006) {
          const currentUser = new UserContext();
          this._sharedService.setErrorMsg(err.error.detailedMessage);
          if (!this._sharedService.loggedUserId.value) {
            this._userService.getHomeUser(currentUser.personID).subscribe({
              next: (res) => {
                const userId = res.body.find(usr => usr.organisation.id == organisationId).id;
                if (userId) {
                  this._sharedService.changeLoggedUserId(userId)
                }
                else {
                  this._sharedService.changeLoggedUserId(this.peopleData.homeUser.id)
                }
              },
              error: () => {
                this._sharedService.changeLoggedUserId(this.peopleData.homeUser.id)
              },
              complete: () => {
                this._router.navigateByUrl('/2FA-authentication');
              }
            })
          }
          else {
            this._router.navigateByUrl('/2FA-authentication');
          }
        }
      }
    })
  }

  private getUserIdByErrorMsg(errMsg: string) {
    const userId: string = errMsg.substr(errMsg.indexOf("\'") + 1, 36);
    this._sharedService.changeLoggedUserId(userId);
  }

  private getHostName() {
    if (this.returnUrl != undefined) {
      if (this.returnUrl.toString().trim().length > 1) {
        const parser = document.createElement('a');
        parser.href = this.returnUrl
        this.hostname = parser.host;
      }
    }
  }

}
